import MuiTabList from "@mui/lab/TabList";
const TabList = MuiTabList;
export default TabList;
